import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useUserSettings } from "../../../context/userSettingsContext";
import { useI18n } from "../../../hooks/useTranslations";
import SvgAddModerator from "../../icons/AddModerator";
import SvgFactory from "../../icons/Factory";
import SvgGroup from "../../icons/Group";
import SvgShoppingCart from "../../icons/ShoppingCart";
import SvgUpload from "../../icons/Upload";
import SvgViewTimeline from "../../icons/ViewTimeline";
import Nav, { NavItemNotification } from "../Nav";
import CarsMenu from "./CarsMenu";
import OthersMenu from "./OthersMenu";
import SubsidiariesMenu from "./SubsidiariesMenu";

type AdministrationMenuProps = {
  closeSidebar: () => void;
};

const AdministrationMenu: FC<AdministrationMenuProps> = ({ closeSidebar }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();
  // const costCentersApi = useCostCentersApi();
  // const carPurchaseApi = useCarPurchasesApi();
  // const aborter = useRef(new AbortController());
  const navigate = useNavigate();
  // const dispatch = useContext(NotificationDispatch);

  // const countImportErrors = costCentersApi.useUserCostCentersCountErrors(
  //   aborter.current.signal,
  //   !!userSettings.permissions.userCostCenters.read,
  // );

  // const purhcasesStatus = carPurchaseApi.useAdminCarPurchasesStatus(
  //   aborter.current.signal,
  //   !!userSettings.permissions.carPurchases.read,
  // );

  // useEffect(() => {
  //   (countImportErrors.error || purhcasesStatus.error) &&
  //     dispatch(showErrorNotification(i18n, countImportErrors.error ?? purhcasesStatus.error));
  // }, [countImportErrors.error, purhcasesStatus.error]);

  const purchaseNotification: NavItemNotification | undefined =
    userSettings.notifications?.carPurchaseArrivingSoon || userSettings.notifications?.carPurchaseExpired
      ? {
          number:
            (userSettings.notifications?.carPurchaseExpired ?? 0) +
            (userSettings.notifications?.carPurchaseArrivingSoon ?? 0),
          color: (userSettings.notifications?.carPurchaseExpired ?? 0) > 0 ? "red" : "yellow",
          onClick: () => navigate("/admin/car_purchases/arriving_soon"),
        }
      : undefined;

  const usersNotification: NavItemNotification | undefined = !!userSettings.notifications?.usersMissingCostCenterCount
    ? {
        number: userSettings.notifications.usersMissingCostCenterCount,
        color: "red",
        onClick: () => navigate("/admin/users?with_import_errors=1"),
      }
    : undefined;

  return (
    <Nav.Group title={i18n.t.common.administration}>
      {!!userSettings.canSeeCars && <CarsMenu closeSidebar={closeSidebar} />}

      {!!userSettings.permissions.carPurchases.read && (
        <Nav.Item
          text={i18n.t.carOrders.plural}
          to="/admin/car_purchases"
          icon={SvgShoppingCart}
          onClick={closeSidebar}
          notification={purchaseNotification}
        />
      )}

      {!!userSettings.permissions.costsImports.read && (
        <Nav.Item text={i18n.t.common.costImports} to="/admin/costs_imports" icon={SvgUpload} onClick={closeSidebar} />
      )}

      {userSettings.canSeeSubsidiaries && <SubsidiariesMenu closeSidebar={closeSidebar} />}

      {!!userSettings.permissions.manufacturers.read && (
        <Nav.Item
          text={i18n.t.manufacturers.plural}
          to="/admin/manufacturers"
          icon={SvgFactory}
          onClick={closeSidebar}
        />
      )}

      {!!userSettings.permissions.users.read && (
        <Nav.Item
          text={i18n.t.users.plural}
          to="/admin/users"
          icon={SvgGroup}
          onClick={closeSidebar}
          notification={usersNotification}
        />
      )}

      {userSettings.permissions.roles.read && (
        <Nav.Item text={i18n.t.common.roles} to="/admin/roles" icon={SvgAddModerator} onClick={closeSidebar} />
      )}

      {userSettings.permissions.clients.read && (
        <Nav.Item text={i18n.t.clients.plural} to="/admin/clients" icon={SvgViewTimeline} onClick={closeSidebar} />
      )}

      <OthersMenu closeSidebar={closeSidebar} />
    </Nav.Group>
  );
};

export default AdministrationMenu;
